import { useEffect } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import { AuthForm } from "@/components/boardblend/auth-form";
import { BoardblendLoader } from "@/components/boardblend/boardblend-loader";
import { authClient } from "@/lib/auth-client";

export default function SignInPage() {
  const router = useRouter();
  const session = authClient.useSession();

  useEffect(() => {
    if (session.data?.user) {
      const target = router.query.returnTo;
      void router.replace(
        typeof target === "string" &&
          target.startsWith("/") &&
          !target.startsWith("//")
          ? target
          : "/dashboard",
      );
    }
  }, [router, session.data?.user]);

  if (session.isPending || session.data?.user) {
    return (
      <main className="route-message">
        <BoardblendLoader />
      </main>
    );
  }

  return (
    <>
      <Head>
        <title>Sign in · Boardblend</title>
      </Head>
      <AuthForm mode="sign-in" />
    </>
  );
}
